var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',{attrs:{"show":_vm.showLoading}},[_c('center',[_c('md-button',{staticClass:"md-raised md-accent",attrs:{"type":"button"},on:{"click":_vm.fechar}},[_vm._v("Fechar")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }